<template>
  <toggle-button
    v-model="slideActive.isCorrectGetPoint"
    :width="35"
    :height="20"
    class="mb-0"
    :color="{checked: '#6A1EBB', unchecked: '#D3D7E1'}"
    @change="handleChange()"
  />
</template>

<script>
import { mapActions, mapState } from 'vuex'
import * as Sentry from '@sentry/vue'
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'
import Socket from '@/socket'
import SlideApi from '@/api/slide'

export default {
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
  },
  methods: {
    ...mapActions(['updateSlideActiveAction', 'setSyncPresentationAction']),
    handleChange() {
      this._updateSlide({
        presentationId: this.presentation.id,
        accessCode: this.presentation.uniqueAccessCode,
        socketId: Socket.getSocketId(),
        presenting: this.$store.getters.isPresenting,
        isCorrectGetPoint: this.slideActive.isCorrectGetPoint,
      })
    },
    async _updateSlide(payload) {
      this.setSyncPresentationAction(1)
      try {
        await SlideApi.updateSlideById(this.slideActive.id, payload)
        this.handleAfterUpdateSlide()
        this.setSyncPresentationAction(2)
      } catch (error) {
        Sentry.captureException(error)
        this.setSyncPresentationAction(3)
      }
    },
    handleAfterUpdateSlide() {
      this.updateSlideActiveAction({
        isCorrectGetPoint: this.slideActive.isCorrectGetPoint,
      })
      utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Right column > Edit setting > Partial scoring',
        `Partial scoring: ${
          this.slideActive.isCorrectGetPoint}`,
      )
    },
  },
}
</script>
